import React from 'react';
import { Container } from 'react-bootstrap';

function PhillipinesSection() {
  return (
    <Container>
    <div className='container'>
      <div className='card mt-4'>
        <div className='card-body'>
          <h2>Philippines</h2>
          <p>
            is an archipelagic country in Southeast Asia. In the western
            Pacific Ocean, it consists of 7,641 islands, with a total area
            of 300,000 square kilometers, which are broadly categorized in
            three main geographical divisions from north to south: Luzon,
            Visayas, and Mindanao.
          </p>
          <p>
            It shares maritime borders with Taiwan to the north, Japan to the
            northeast, Palau to the east and southeast, Indonesia to the south,
            Malaysia to the southwest, Vietnam to the west, and China to the
            northwest. It is the world's twelfth-most-populous country, with
            diverse ethnicities and 
            cultures.
          </p>
          <p>
            The current president of the Philippines is Bongbong Marcos who assumen
            the power of the country in June 2022.
          </p>
        </div>
        <div className='ratio ratio-16x9'>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/mhYbH56Yxyk?si=BprOuuFtGEJ_wcwJ" title="YouTube video player" 
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerpolicy="strict-origin-when-cross-origin" allowFullScreen>
        </iframe>
        </div>
      </div>
    </div>
    <br></br>
    </Container>
  );
}

export default PhillipinesSection;